/**
 * Translate a raw axios/fetch error into a user-friendly string.
 *
 * Usage:
 *   import { friendlyErrorMessage } from '../../../lib/errorCopy.js';
 *   const msg = friendlyErrorMessage(err);
 *
 * Rules (in priority order):
 *  1. navigator.onLine === false  → offline copy
 *  2. HTTP 401 → session-expired copy
 *  3. HTTP 403 → permission copy
 *  4. HTTP 404 → not-found copy
 *  5. HTTP 5xx → server-trouble copy
 *  6. axios Network Error / ERR_NETWORK → connection copy
 *  7. fallback (caller-supplied or default)
 */
export function friendlyErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return "You're offline. Reconnect and try again.";
  }
  const status = err?.response?.status;
  if (status === 401) return 'Your session has expired. Please sign in again.';
  if (status === 403) return "You don't have permission to do that.";
  if (status === 404) return "We couldn't find what you're looking for.";
  if (status >= 500) return 'Our service is having trouble right now. Please try again in a moment.';
  if (err?.message === 'Network Error' || err?.code === 'ERR_NETWORK') {
    return "We couldn't reach our service. Check your connection and try again.";
  }
  return fallback;
}
